// Records HOW a shopper reached the order flow, on their cart.
//
// Extracted from AccessCodeOnlyForm so it can be unit-tested without React --
// the same reason stampLinkAttribution lives in a plain function, and the same
// reason it needs testing: it crashed the highest-traffic entry form.
//
// THE CART IS NOT ALWAYS A MODEL. `CustomerContext#rehydrate` restores the
// customer from localStorage with the line that would rebuild the Cart model
// commented out (its own FIXME: "passing cart to constructor throws error"),
// and the G1 self-heal only replaces a cart that is DEAD -- a live restored one
// keeps its plain-object shape for the life of the page. So any returning
// visitor with a cart carries one that has attributes but no methods.
//
// Calling `isDirty()` on that threw `customer.cart.isDirty is not a function`
// and took the Continue button down with it, which is the whole reason this
// exists. `stampLinkAttribution` already guards the same trap with
// `!cart.save`; this is that guard, applied to the sibling call site that did
// not have it.
//
// Skipping the save on a plain-object cart turned out to be a real loss, not
// an edge case: every returning visitor carries one, and about a third of the
// fall 2026 home-page carts that were bought had no entry method because of
// it. So when the caller passes `loadCart` (id -> Promise<Cart model>), the
// stamp is saved on a freshly LOADED model for the same row -- Cart.find, the
// pattern CustomerContext already uses -- rather than on a hand-rebuilt one,
// which would mean guessing at spraypaint's persisted-vs-new semantics.
export function stampEntryMethod(cart, { createdLocation, loadCart } = {}) {
  if (!cart) return false;

  if (createdLocation) cart.createdLocation = createdLocation;
  cart.entryMethod = 'typed_code';

  // The stored copy can't say whether the server row is stamped (an earlier
  // save may have failed), so the LOADED model decides whether to save.
  if (typeof cart.save !== 'function' && loadCart && cart.id) {
    loadCart(cart.id)
      .then((model) => {
        if (!model) return undefined;
        const stamped = model.entryMethod === 'typed_code'
          && (!createdLocation || model.createdLocation === createdLocation);
        if (stamped) return undefined;

        if (createdLocation) model.createdLocation = createdLocation;
        model.entryMethod = 'typed_code';
        return model.save();
      })
      // Attribution only: never break the Continue button, but leave a trace.
      // eslint-disable-next-line no-console
      .catch((e) => console.warn('[stampEntryMethod] could not save the entry method', e));
    return true;
  }

  // Only PATCH when something actually changed: this is the highest-traffic
  // entry form, and a resubmit or a typo must not re-save an unchanged cart.
  if (typeof cart.isDirty !== 'function' || typeof cart.save !== 'function') return false;
  if (!cart.isDirty()) return false;

  cart.save();
  return true;
}

export default stampEntryMethod;
